import { render, staticRenderFns } from "./Mines.vue?vue&type=template&id=f670bfde&scoped=true"
import script from "./Mines.vue?vue&type=script&lang=js"
export * from "./Mines.vue?vue&type=script&lang=js"
import style0 from "./Mines.vue?vue&type=style&index=0&id=f670bfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f670bfde",
  null
  
)

export default component.exports